import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const PlayAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0;
  position:relative;
  z-index: 100;

  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    display: ${theme.playArea?.container?.display || 'flex'};
    flex-direction: ${theme.playArea?.container?.flexDirection || 'column'};
    width: ${theme.playArea?.container?.width || '100%'};
    height: ${theme.playArea?.container?.height || '100%'};
    margin: ${theme.playArea?.container?.margin || '0'};
  `}
`;

export const PlayArea = ({ children, ...props }) => {
  return <PlayAreaContainer {...props}>{children}</PlayAreaContainer>;
};

PlayArea.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PlayArea;
